import { render } from "./SearchSuggestPanel.vue?vue&type=template&id=115595c4&scoped=true"
import script from "./SearchSuggestPanel.vue?vue&type=script&lang=js"
export * from "./SearchSuggestPanel.vue?vue&type=script&lang=js"

import "./SearchSuggestPanel.vue?vue&type=style&index=0&id=115595c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115595c4"]])

export default __exports__